import makeStyles from '@mui/styles/makeStyles';

export default makeStyles({
  listHeading: {
    padding: '6px 16px',
  },
  scrollFix: {
    overflow: 'hidden',
  },
});
